import db from '@/plugins/database'
import { cleanColumns } from '@/store/mutations'
import { useDeckStore } from '@/store'
import type { Router } from 'vue-router'

let dbOpened = false

export default function useDb(router: Router) {
  router.beforeEach(async to => {
    await db.open()
    if (!dbOpened) {
      dbOpened = true
      // Purge des documents orphelins accumulés depuis la dernière session.
      // En arrière-plan (best-effort, erreurs déjà avalées par cleanColumns) :
      // ne doit pas retarder la navigation en cours.
      void cleanColumns()
    }

    if (to.name === 'document' || to.name === 'ai-document') {
      const routeDocId = to.params.docId
      if (typeof routeDocId !== 'string') return

      let docId = routeDocId

      const { loadDocument, loadDocFromShortId } = useDeckStore()

      // Si l'identifiant est un shortId, le convertir en long id
      if (/^[A-Z0-9]{5,9}$/i.test(docId)) {
        docId = (await loadDocFromShortId(docId)).id
        to.params.docId = docId

        return {
          ...to,
          replace: true
        }
      } else {
        to.params.docId = docId
      }

      // loadDocument lit directement depuis IndexedDB, ce qui sert aussi de
      // tampon temporel permettant au liveQuery de state.ts d'émettre avant le rendu du viewer.
      await loadDocument(docId)
    }
  })
}
